import { sectionMedia } from '../../../style/scrollingLayout'

/**
 * Below this the second column cannot hold the whole buy box — a title breaks
 * to one word a line and swatches wrap — so only the product's identity sits
 * beside the gallery and everything a shopper acts on drops below it.
 */
const SPLIT_BUY_BOX_MAX_PX = 650

/** From here the buy box has its own column beside the gallery. */
export const wideTwoColumn = sectionMedia(SPLIT_BUY_BOX_MAX_PX)
